import Education from './components/Education/';
import Spinner from '../../../../../../components/Spinner/';

import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

const EducationUserData = gql`
query EducationUserData {
  viewer {
    degrees {
      id
      graduation_id
      graduation_date
      degree_type {
        id
        name
      }
      university {
        id
        name
      }
      major {
        id
        name
      }
    }
  }
  
  getDegreeTypes {
    id
    name
  }
}
`;


const UpsertMajor = gql`
mutation($Name: String!) {
  createMajor (
    name: $Name
  ) {
    id
    name
  }
}
`;

const UpsertGraduation = gql`
mutation(
  $Id: Int
  $MajorID: Int!
  $UniID: Int!
  $DegreeTypeID: Int!
  $GraduationDate: String
) {
  upsertUserGraduation (Graduation: {
    graduation_id: $Id
    major_id: $MajorID
    university_id: $UniID
    degree_type_id: $DegreeTypeID
    graduation_date: $GraduationDate
  }) {
    degrees {
      id
      graduation_id
      graduation_date
      degree_type {
        id
      }
      university {
        id
      }
      major {
        id
      }
    }
  }
}
`;

const SetUserGraduation = gql`
mutation ($Graduations: [UserGraduationInput]) {
	setUserGraduations(Graduations: $Graduations) {
	  id
	}
}
`;

const deleteGraudation = gql`
mutation(
  $Id: Int!
) {
  deleteUserGraduation(
    id: $Id
  ) {
    id
  }
}
`;

export default (store) => ({
    path: 'education',
    component: compose(
        graphql(EducationUserData, {
            name: 'EducationUserData',
            options: {
                fetchPolicy: 'network-only'
            },
        }),
        graphql(UpsertMajor, {
            name: 'UpsertMajor',
        }),
        graphql(UpsertGraduation, {
            name: 'UpsertGraduation',
        }),
        graphql(deleteGraudation, {
            name: 'DeleteGraudation',
        }),
        graphql(SetUserGraduation, {
            name: 'SetUserGraduations',
        })
    )((props) => {
        if (props.EducationUserData.loading === false) {
            return <Education {...props} />;
        }
        return <Spinner />;
    }),
});



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Profile/routes/Education/index.js